import { useState } from "react";
import {
  PanelShell, Badge, StatChip, Button,
  initialProgress, resolveChecklist, progressPct, markComplete, LOCAL_FILE_PERMISSION_COPY,
} from "../index";

/**
 * Dashboard module — the workspace home screen: onboarding progress at a glance, a checklist
 * of getting-started steps with per-step completion, and the canonical local-file safety notes.
 *
 * @returns A workspace summary panel, a "Get started" checklist panel, and a local file safety panel.
 */
export function DashboardModule() {
  const [progress, setProgress] = useState(initialProgress());
  const items = resolveChecklist(progress);
  const pct = progressPct(progress);
  return (
    <>
      {/* Workspace at a glance — the guardrail journey in numbers. */}
      <PanelShell title="Workspace">
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
          <StatChip label="Onboarding" value={`${pct}%`} tone={pct === 100 ? "ok" : "accent"} />
          <StatChip label="Steps done" value={`${items.filter((i) => i.done).length}/${items.length}`} />
          <StatChip label="Next up" value={items.find((i) => !i.done && i.available)?.label.split(" ")[0] ?? "—"} />
        </div>
      </PanelShell>

      <PanelShell title="Get started" style={{ marginTop: 12 }}>
        {items.map((it) => (
          <div key={it.id} style={{
            display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12,
            padding: "8px 2px", opacity: it.available ? 1 : 0.45,
            borderBottom: "1px solid rgba(26,31,43,0.6)",
          }}>
            <span style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13 }}>
              <span aria-hidden style={{ color: it.done ? "#7fce9e" : "#6c7280", width: 14, textAlign: "center" }}>{it.done ? "✓" : "○"}</span>
              <span style={{ color: it.done ? "#6c7280" : undefined, textDecoration: it.done ? "line-through" : undefined }}>{it.label}</span>
              <Badge>{it.module}</Badge>
            </span>
            <Button disabled={!it.available || it.done} onClick={() => setProgress((p) => markComplete(p, it.id))}>
              {it.done ? "Done" : "Mark done"}
            </Button>
          </div>
        ))}
      </PanelShell>

      <PanelShell title="Local file safety (canonical)" style={{ marginTop: 12 }}>
        {LOCAL_FILE_PERMISSION_COPY.map((line, i) => (
          <div key={i} style={{ fontSize: 12, marginBottom: 6, color: "#a9adb7", paddingLeft: 14, position: "relative" }}>
            <span style={{ position: "absolute", left: 0, color: "#c9a35a" }}>—</span>{line}
          </div>
        ))}
      </PanelShell>
    </>
  );
}
